import {
  Box,
  Card,
  CardHeader,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Button
} from '@mui/material';
import HeaderAnalytics from './HeaderAnalytics';
import React, { useState } from 'react';
import Iconify from 'src/components/iconify';
import { TableNoData } from 'src/components/table';

export default function CounterWithTablewithoutGraph({
  title,
  tableLabels,
  tableData,
  headerAnalyticsData,
  ...other
}) {
  const [page, setPage] = useState(0);
  const rowsPerPage = 4;
  const maxPages = 3;

  const cappedTableData = tableData?.slice(0, rowsPerPage * maxPages) || [];
  const currentRows = cappedTableData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const totalPages = Math.ceil(cappedTableData.length / rowsPerPage);

  const renderTableCellValue = (value) => {
    const isProbablyDateString =
      typeof value === 'string' && /^\d{4}-\d{2}-\d{2}(T.*)?$/.test(value);
    if (value instanceof Date || isProbablyDateString) {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('en-US');
      }
    }
    return value !== undefined ? value : '-';
  };

  const handlePageChange = (newPage) => setPage(newPage);
  const handleNextPage = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };
  const handlePrevPage = () => {
    if (page > 0) setPage(page - 1);
  };

  return (
    <Card {...other} sx={{ width: '100%', overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CardHeader title={title} sx={{ mb: 2, flex: '1 1 auto' }} />
        {headerAnalyticsData ? (
          <HeaderAnalytics
            title={headerAnalyticsData?.name}
            total={headerAnalyticsData?.counter}
            chart={{ colors: '' }}
          />
        ) : (
          <HeaderAnalytics title="No Data" total={0} chart={{ colors: '' }} />
        )}
      </Box>

      <Card sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, m: 2, mt: 0 }}>
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer
            sx={{
              minHeight: 224,
              maxHeight: 280,
              overflowY: 'auto',
              '&::-webkit-scrollbar': { display: 'none' },
              '-ms-overflow-style': 'none',
              'scrollbar-width': 'none',
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {tableLabels?.map((label) => (
                    <TableCell
                      key={label?.id}
                      sx={{
                        minWidth: { xs: 100, sm: label?.minWidth || 150 },
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'background.default',
                        zIndex: 2,
                        padding: '4px 8px',
                        fontSize: '14px',
                      }}
                    >
                      {label?.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
  {currentRows.length > 0 ? (
    currentRows.map((row, rowIndex) => (
      <TableRow key={`${row?.id || 'no-id'}-${rowIndex}`}>
        {tableLabels.map((label) => (
          <TableCell key={label?.id} sx={{ padding: '4px 8px', fontSize: '14px', height: 56 }}>
            {renderTableCellValue(row?.[label?.id])}
          </TableCell>
        ))}
      </TableRow>
    ))
  ) : (
    <TableNoData notFound="No Data" sx={{ width: '100%', textAlign: 'center' }} />
  )}

  {Array.from({ length: rowsPerPage - currentRows.length }).map((_, index) => (
    <TableRow key={`empty-${index}`} sx={{ height: 56 }}>
      {tableLabels.map((label) => (
        <TableCell key={label?.id} sx={{ padding: '4px 8px' }} />
      ))}
    </TableRow>
  ))}
</TableBody>

            </Table>
          </TableContainer>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 2 }}>
            <Iconify
              icon={'material-symbols:arrow-circle-left-rounded'}
              onClick={handlePrevPage}
              disabled={page === 0}
              sx={{
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                minWidth: '30px',
                padding: 0,
                fontSize: '16px',
                color: page === 0 ? 'grey' : 'primary.main',
                cursor: page === 0 ? 'not-allowed' : 'pointer',
              }}
            />

            {[...Array(totalPages)].map((_, index) => (
              <Button
                key={index}
                onClick={() => handlePageChange(index)}
                variant={page === index ? 'contained' : 'outlined'}
                sx={{
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px',
                  minWidth: '30px',
                  padding: 0,
                  fontSize: '14px',
                  backgroundColor: page === index ? 'grey' : 'transparent',
                  color: 'primary.main',
                  '&:hover': {
                    backgroundColor: page === index ? 'grey' : 'rgba(0, 0, 0, 0.08)',
                  },
                }}
              >
                {index + 1}
              </Button>
            ))}

            <Iconify
              icon={'material-symbols:arrow-circle-right-rounded'}
              onClick={handleNextPage}
              disabled={page === totalPages - 1}
              sx={{
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                minWidth: '30px',
                padding: 0,
                fontSize: '16px',
                color: page === totalPages - 1 ? 'grey' : 'primary.main',
                cursor: page === totalPages - 1 ? 'not-allowed' : 'pointer',
              }}
            />
          </Box>
        </Box>
      </Card>
    </Card>
  );
}